// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__kiqAW","log":"ModalInventoryLogs_log__1KJzB","date":"ModalInventoryLogs_date__1FOsn","userName":"ModalInventoryLogs_userName__3vugz"};